var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGuiaSistemas(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 967 289",
    width: 967,
    height: 289,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".a{fill:#242480}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m0.5 157.6c0.8 9.2 2.5 18.1 5 26.8l151.9-28.9zm143.4-157.5c-24.2 0-47.1 6-67.1 16.6 53.2 27 114.5 58 114.5 58l-140-40.8c-11.2 9.4-21 20.5-28.9 32.9l110.4 25.4-25.6-24.8 83.5 37.7 27.2 34.2 34.5 16.6 7.2 45-11.7-9.9-57.8-5.9-169.4 33.8c8.2 13.5 18.6 25.5 30.6 35.6l140-40.8c0 0-61.3 30.9-114.5 57.9 20 10.6 42.9 16.6 67.1 16.6 79.6 0 144.1-64.5 144.1-144 0-79.6-64.5-144.1-144.1-144.1zm24.2 132.9q0.4 0.4 0.8 0.8c2.3 2.4 5.8 4 9.7 4 7 0 12.7-4.9 12.7-10.9q0-0.6-0.1-1.1c-4.1-0.8-113.6-21.7-181.4-34.2-3.6 9.1-6.2 18.6-7.9 28.5l157.4 2.6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m391.2 246.8c0 2.3 1.8 4.1 5.3 4.1 3.5 0 4.9-1.4 4.9-3.1 0-1.4-1-2.4-4.1-3l-4.5-0.8c-5.1-1-7.5-3.5-7.5-8 0-4.9 3.8-8.8 10.8-8.8 7.6 0 11.7 4.1 11.7 9.8h-6.6c0-2.2-1.9-4.1-5.1-4.1-2.9 0-4.3 1.4-4.3 3.1 0 1.4 0.8 2.2 3.5 2.6l4.5 0.9c5.7 1 8.2 3.4 8.2 8.3 0 5-3.9 8.8-11.5 8.8-7.5 0-11.9-4.3-11.9-9.8z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m461.6 227.6h6.5v28.6h-6.5z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m527.9 246.8c0 2.3 1.8 4.1 5.3 4.1 3.5 0 4.9-1.4 4.9-3.1 0-1.4-1-2.4-4.1-3l-4.5-0.8c-5.1-1-7.6-3.5-7.6-8 0-4.9 3.9-8.8 10.9-8.8 7.6 0 11.6 4.1 11.6 9.8h-6.5c0-2.2-1.9-4.1-5.1-4.1-2.9 0-4.3 1.4-4.3 3.1 0 1.4 0.8 2.2 3.5 2.6l4.5 0.9c5.7 1 8.2 3.4 8.2 8.3 0 5-3.9 8.8-11.5 8.8-7.5 0-11.9-4.3-11.9-9.8z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m603.4 233.9h-8v-6.3h22.5v6.3h-8v22.3h-6.5z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m670.7 227.6h19.6v5.9h-13v5.6h12.2v5.7h-12.2v5.5h13v5.9h-19.6z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m744.4 227.6h10l5.7 17.8h0.9l5.7-17.8h10v28.6h-6.5v-17.6h-0.9l-5.7 17.6h-6.1l-5.8-17.6h-0.8v17.6h-6.5z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "a",
    d: "m838.3 227.6h9.4l9.8 28.6h-7.1l-1.9-5.7h-11l-1.9 5.7h-7.1zm8.4 17.2l-3.3-10.2h-0.8l-3.3 10.2z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m914.2 246.8c0 2.3 1.9 4.1 5.3 4.1 3.5 0 4.9-1.4 4.9-3.1 0-1.4-0.9-2.4-4-3l-4.5-0.8c-5.2-1-7.6-3.5-7.6-8 0-4.9 3.8-8.8 10.8-8.8 7.6 0 11.7 4.1 11.7 9.8h-6.6c0-2.2-1.8-4.1-5.1-4.1-2.9 0-4.3 1.4-4.3 3.1 0 1.4 0.9 2.2 3.5 2.6l4.5 0.9c5.7 1 8.2 3.4 8.2 8.3 0 5-3.9 8.8-11.5 8.8-7.5 0-11.8-4.3-11.8-9.8z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m622.8 189.6h-20.2l-0.4-17.9c-8.8 12.9-24.8 22.1-47.4 22.1-38.7 0-68.4-27.8-68.4-68 0-40.4 28.5-68 71.3-68 28.5 0 57.4 13.5 63.6 46.3h-34c-4.1-9.9-14.7-16.7-29-16.7-22.2 0-37.9 15.7-37.9 38.4 0 22.8 16.1 38.4 37 38.4 10.5 0 27.9-4.2 32.2-22.1h-19.5v-21h52.7z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m636.1 135.7v-73.6h34.5v72.7c0 18.8 9.1 30.2 28.5 30.2 19.5 0 28.9-11.4 28.9-30.2v-72.7h34.1v73.4c0 39.8-22.1 58.3-63 58.3-40.8 0-63-18.5-63-58.1z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m777 62.1h34.3v127.5h-34.3z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "a",
    d: "m924.1 169.7h-60.2l-7.1 19.9h-35.4l48.6-127.5h48l48.6 127.5h-35.4zm-9.1-25.7l-21-82-20.9 82z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "a",
    d: "m452.8 169.7h-60.1l-7.1 19.9h-35.4l48.6-127.5h48l48.5 127.5h-35.3zm-9.1-25.7l-21-82-20.9 82z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m432.1 31.6h32.1l-41.4 30.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGuiaSistemas);
export default __webpack_public_path__ + "static/media/Águia Sistemas.05fe1e80f60852d58bc15ff8473fced9.svg";
export { ForwardRef as ReactComponent };